import { Moon, Sun } from 'lucide-react';

import { useTheme } from '../hooks/useTheme';
import { t } from '../lib/i18n';
import { useAppStore } from '../store';

/**
 * Sun/moon toggle in the header. Click flips light↔dark and locks in that
 * choice (subsequent system-pref changes are ignored — see useTheme).
 */
export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const lang = useAppStore((s) => s.lang);
  const isDark = theme === 'dark';
  const Icon = isDark ? Sun : Moon;
  const label = t(lang, isDark ? 'theme.toLight' : 'theme.toDark');

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
      className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition-colors hover:bg-slate-100 hover:text-slate-900 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-100"
    >
      <Icon className="h-4 w-4" aria-hidden="true" />
    </button>
  );
}
